import React from "react";
import { WizardContext } from "../../features/documents/useWizardContext.js";

type ProjectQuoteContextType = {
  projectId: string;
  quoteId: string;
  activeWizardContext: WizardContext;
  selectWizardContextButton: React.ReactElement | null;
  hasItemAnyQuestions: (itemId: string) => boolean;
  refetchWizardQuestions: () => Promise<any>;
};

export const ProjectQuoteContext = React.createContext<
  ProjectQuoteContextType | undefined
>(undefined);

export const useProjectQuoteContext = () => {
  const context = React.useContext(ProjectQuoteContext);
  if (!context) {
    throw new Error(
      "useProjectQuoteContext must be used within a ProjectQuoteContextProvider"
    );
  }

  return context;
};
